<template>
  <header class="c-Header">
    <section class="c-Header__main main-container">
      <div class="content-container">
        <div class="c-Header__leftBlock">
          <a class="c-Header__logo" href="#" title="logo"></a>
        </div>
        <button type="button" :class="{active: showMobileMenu}" @click="handleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </section>
    <section class="c-Header__secondary main-container" :class="{active: showMobileMenu}">
      <div class="content-container">
        <nav class="c-Header__navigation">
          <ul>
            <li><a href="#" @click="showMobileMenu = false;">Discover</a></li>
            <li><a href="#" @click="showMobileMenu = false;">Book & Manage</a></li>
            <li><a href="#" @click="showMobileMenu = false;">Travel Information</a></li>
            <li><a href="#" @click="showMobileMenu = false;">Liberty Advantage</a></li>
            <li><a href="#get-in-touch" v-smooth-scroll @click="showMobileMenu = false;">Customer Support</a></li>
            <li><a href="https://d3v-flyairliberty.zendesk.com/hc/" target="_blank" rel="noopener noreferrer" @click="showMobileMenu = false;">Help Center</a></li>
          </ul>
        </nav>
        <nav class="c-Header__navigation">
          <ul>
            <li>
              <i class="c-Header__navigation--userIcon"></i>
              <a href="#" @click="showMobileMenu = false;">Sign in</a>
            </li>
            <li><a href="#" @click="showMobileMenu = false;">Join</a></li>
          </ul>
        </nav>
        <button type="button" :class="{active: showMobileMenu}" @click="handleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      showMobileMenu: false
    }
  },
  methods: {
    handleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-Header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  .content-container {
    justify-content: space-between;
  }

  &__main {
    background-color: $blue;
    padding: $base-padding 0;
    color: #FFFFFF;
  }

  &__logo {
    background-image: url('~@/assets/air_liberty_logo.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 225px;
    height: 45px;
    display: inline-block;
  }

  &__rightBlock {
    display: flex;
    align-items: center;

    > div {
      cursor: pointer;
    }
  }

  &__magGlass {
    background-image: url('~@/assets/mag_glass.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 19px;
    height: 19px;
    display: inline-block;
    // margin-right: $base-margin;
    cursor: pointer;
  }

  &__flag {
    background-image: url('~@/assets/us_flag.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 28px;
    height: 20px;
    display: inline-block;
    margin-right: $base-margin;
  }

  &__arrow {
    background-image: url('~@/assets/arrow_lang.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    width: 10px;
    height: 6px;
    display: inline-block;
    margin-left: $base-margin;
  }

  &__secondary {
    background-color: $orange;
    height: 45px;
    color: #FFFFFF;
  }

  &__navigation {
    ul {
      list-style: none;
      display: flex;
      margin: 0;
      padding: 0;

      li {
        margin: 0;
        padding: 0 $base-padding;
        border-right: 1px solid #FFFFFF;
        display: flex;
        align-items: center;

        a {
          font-weight: bold;
          color: #FFFFFF;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          border-right: none;
        }
      }

      &:last-child {
        li:last-child {
          padding-right: 0;
        }
      }
    }

    &--userIcon {
      background-image: url('~@/assets/user_logo.svg');
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      display: inline-block;
      margin-right: $base-margin;
    }
  }

  button {
    border: none;
    background-color: transparent;
    width: 30px;
    height: 20px;
    position: relative;
    cursor: pointer;
    display: none;

    span {
      width: 100%;
      height: 2px;
      background-color: #FFFFFF;
      position: absolute;
      left: 0;
      transition: all 200ms ease-in-out;

      &:nth-child(1) {
        top: 0;
        transform-origin: top right;
      }

      &:nth-child(2) {
        top: 9px;
      }

      &:nth-child(3) {
        top: 18px;
        transform-origin: bottom right;
      }
    }

    &.active span {
      &:nth-child(1) {
        transform: rotateZ(-45deg);
        width: 39px;
        left: -12px;
        top: -1px;
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:nth-child(3) {
        transform: rotateZ(45deg);
        width: 38px;
        left: -11px;
        top: 26px;
      }
    }
  }
}

@include desktop-sm {
  .c-Header {
    &__secondary {
      i {
        display: none;
      }

      ul li {
        padding: 0 calc(#{$base-padding} * 0.85)
      }
    }
  }
}

@include tablet {
  .c-Header {
    &__logo {
      height: 30px;
      width: 150px;
    }

    button {
      display: block;
    }

    &__navigation:first-child ul li:last-child {
      margin-bottom: $base-margin;
    }

    &__secondary {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 0;
      z-index: 1000;
      transition: height 300ms ease-in-out;
      background-color: $blue;

      .content-container {
        visibility: hidden;
        opacity: 0;
        transition: all 300ms ease-in-out;
        display: block;
        padding: calc(#{$base-padding} * 1.5) calc(#{$base-padding} * 2) !important;

        ul {
          display: block;

          li {
            align-items: left;
            border-right: none;
            padding: calc(#{$base-padding}) 0;

            &:first-child {
              padding-top: 0;
            }

            // &:last-child {
            //   padding-bottom: 0;
            // }

            a {
              font-size: 20px;
            }
          }

          i {
            display: none;
          }
        }
      }

      &.active {
        height: 100vh;

        .content-container {
          visibility: visible;
          opacity: 1;
        }
      }

      button {
        position: absolute;
        top: $base-margin;
        right: $base-margin;
      }
    }
  }
}
</style>
